<template>
  <div class="navigation">
    <el-collapse v-model="navigationCollapse" accordion>
      <el-collapse-item name="1">
        <template slot="title">
          <i class="header-icon el-icon-rank"></i> Навигация
        </template>

        <div class="navigation__wrapper">
          <div class="indicator" :style="indicatorStyle"></div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  props: {
    viewSize: {}
  },
  data: function () {
    return {
      navigationCollapse: "1"
    }
  },
  computed: {
    indicatorSizes() {

      return {

      }
    },
    indicatorStyle () {
      if(!this.viewSize) return {}

      return  {
        width: (180 / (this.viewSize.w / this.viewSize.wOff)) + 'px',
        height: (230 / (this.viewSize.h / this.viewSize.hOff)) + 'px',
        left: (180 / (this.viewSize.w / this.viewSize.wScroll)) + 'px',
        top: (230 / (this.viewSize.h / this.viewSize.hScroll)) + 'px',
      }
    }
  },
  methods: {

    drop(e) {
      console.log('drop', e)
    },
    sizeIndicator () {


      return {
        w:  120,
        h: 60
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navigation {
  position: absolute;
  z-index: 9;
  right: 25px;
  bottom: 56px;
  width: 204px;

  background: #FFFFFF;
  border: 1px solid #EAEAEA;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 12px;

  /deep/ {
    .el-collapse-item__header {
      border-radius: 12px;
    }
    .el-collapse-item__wrap {
      border-radius: 12px;
    }
    .el-collapse-item {
      background: transparent;
    }
  }

  &__wrapper {
    width: 180px;
    height: 230px;

    background: #F6F8F9;

    position: relative;
    z-index: 10;
  }
}

.indicator {
  position: absolute;
  z-index: 10;

  left: 12px;
  top: 40px;

  border: 2px solid #43D3B3;
  box-sizing: border-box;
}

.header-icon {
  padding-right: 10px;
  font-size: 13px;
}
</style>